<script lang="ts" setup>
import { usePool } from "@/features/pool/usePool";
import { useBrowse } from "@/shared/mixins/useLink";
import { Token } from "@/models/auth.models";
import config from "@/config";
import { inject, ComputedRef, ref } from "vue";
import KlereoModal from "@/shared/components/KlereoModal.vue";

const pool = usePool();
const browse = useBrowse();
const token = inject("token") as ComputedRef<Token>;

const permission = pool.access ?? token.value.dac;

const externalLinksRoot = config.externalLinksRoot;

const showModal = ref(false);
</script>

<template>
  <div>
    <klereo-modal
      :opened="showModal"
      :with-close-button="true"
      @close="showModal = false"
    >
      <div class="mb-5">
        <h2 class="font-bold mb-2">{{ $t("ParamRedirTittle") }}</h2>
        {{ $t("ParamRedirText") }}
      </div>

      <div class="flex gap-2 justify-end">
        <div class="btn--secondary" @click="showModal = false">
          {{ $t("Abort") }}
        </div>
        <div
          class="btn--primary"
          @click="
            browse({
              url: externalLinksRoot + `/pro`,
            })
          "
        >
          {{ $t("MyAppLink") }}
        </div>
      </div>
    </klereo-modal>

    <a
      v-if="permission >= 20"
      @click="
        permission >= 40
          ? browse({
              url:
                externalLinksRoot +
                `/v1/?page=parameters&poolId=${pool.idSystem}`,
            })
          : (showModal = true)
      "
      class="card text-center p-4 font-medium cursor-pointer flex flex-col items-center justify-center"
      ><span class="text-bluenew uppercase">
        {{ $t("Params") }}
      </span>
      <klereo-icon name="cog" class="m-2 w-[32px]" />
    </a>
  </div>
</template>
